import * as React from 'react'
const SvgChevronRight = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(function SvgChevronRight(
    props,
    svgRef,
) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" ref={svgRef} {...props}>
            <path
                d="M9.62 7.625l-2.49-2.49a.53.53 0 10-.75.75L8.496 8 6.38 10.115a.529.529 0 10.75.75l2.49-2.49a.53.53 0 000-.75z"
                fill="#101010"
                fillRule="evenodd"
            />
        </svg>
    )
})
export default SvgChevronRight
